import { useContext } from "react";
import { Card } from "react-bootstrap";
import {
  RiCarFill,
  RiCheckboxCircleFill,
  RiTimeLine,
  RiCalendarEventLine,
  RiErrorWarningLine
} from "react-icons/ri";
import { AuthContext } from "../../states/AuthContext";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default function RightPanel({notifications}) {
  const { userProfileData } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <div className="right-panel">

      {/* ALERT PREVIEW */}
      <Card className="rp-card">
        <h6>Alert Preview</h6>
        <p className="sub">This is how your alerts will be delivered.</p>

        <div className="alert-preview-box">
          {/* <span className="badge critical">CRITICAL</span> */}

          <div className="preview-content">
            <div className="icon red">
              <RiCarFill />
            </div>

            <div>
              <h6>Driver Entered Lot</h6>
              <p>John Miller entered Main Yard</p>
              <span className="time">Today, Apr 24, 2026 at 7:43 AM</span>

              <div className="tags">
                <span>John Miller</span>
                <span>Truck 423</span>
                <span>Main Yard</span>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* DELIVERY CHANNELS */}
      <Card className="rp-card mt-3">
        <h6>Delivery Channels</h6>

        <div className="channel">
          <div>
            <RiCheckboxCircleFill className="green" />
            <span>Email</span>
          </div>
          <span className="email text-wrap text-break small">{userProfileData?.email || ""}</span>
          {/* <span className="status success ms-1">Delivered</span> */}
        </div>

        <div className="channel">
          <div>
            <RiCheckboxCircleFill className="green" />
            <span>SMS</span>
          </div>
          <span>{userProfileData?.phoneNumber || "" }</span>
          {/* <span className="status success">Delivered</span> */}
        </div>

        <div className="channel">
          <div>
            <RiCheckboxCircleFill className="green" />
            <span>In-App</span>
          </div>
          <span>TruckTuck App</span>
          {/* <span className="status success">Delivered</span> */}
        </div>
      </Card>

      {/* RECENT ALERT HISTORY */}
      {notifications?.length > 0 &&
        <Card className="rp-card mt-3">
          <div className="d-flex justify-content-between">
            <h6>Recent Alert History</h6>
            {/* <span className="link">View All</span> */}
          </div>

          <div className="history">
            {/* <div className="history-item">
            <RiCarFill className="red" />
            <span>Driver Entered Lot</span>
            <span className="time">Today, 7:43 AM</span>
          </div>

          <div className="history-item">
            <RiCarFill className="green" />
            <span>Driver Left Lot</span>
            <span className="time">Today, 6:15 AM</span>
          </div> */}

          
            <div className="history-item">
              <RiTimeLine className="orange" />
              <span>{notifications[0]?.title || ""}  </span>
              <span className="time"> {notifications[0]?.createdAt ? moment(notifications[0]?.createdAt).local().format("MMM DD, hh:mm A") : "s"}
              </span>
            </div>

            <div className="history-item">
              <RiTimeLine className="orange" />
              <span>{notifications[1]?.title || ""}  </span>
              <span className="time">{notifications[1]?.createdAt ? moment(notifications[1]?.createdAt).local().format("MMM DD, hh:mm A") : ""}
              </span>
            </div>
          </div>
        </Card>
      }

      {/* HELP */}
      <Card className="rp-card mt-3 help">
        <h6>Need Help?</h6>
        <span className="link" onClick={()=>navigate("/support")}>Message us on support</span>
      </Card>

    </div>
  );
}